import React from 'react'

const BookmarkIcon = () => {
    return (
        <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.1461 1H4.47288C2.5565 1 1 2.5655 1 4.47288V17.1498C1 18.7693 2.16063 19.453 3.58217 18.6703L7.97274 16.2321C8.44059 15.9712 9.19635 15.9712 9.6552 16.2321L14.0458 18.6703C15.4673 19.462 16.6279 18.7783 16.6279 17.1498V4.47288C16.6189 2.5655 15.0625 1 13.1461 1Z" stroke="#D6D6D6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M6.64014 9.10084L7.98967 10.4504L11.5885 6.85156" stroke="#292D32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    )
}

export default BookmarkIcon
